"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "porto-ceresio": {
    "142361f2": [{
      "hkey": "1678313b",
      "slug": "porto-ceresio",
      "name": "Porto Ceresio",
      "primary": true,
      "skipSearch": false
    }],
    "albero-di-sella": [{
      "hkey": "1678313b",
      "slug": "porto-ceresio",
      "name": "Porto Ceresio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5c83c091": [{
      "hkey": "1678313b",
      "slug": "porto-ceresio",
      "name": "Porto Ceresio",
      "primary": true,
      "skipSearch": false
    }],
    "case-moro": [{
      "hkey": "1678313b",
      "slug": "porto-ceresio",
      "name": "Porto Ceresio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "76bbdfbe": [{
      "hkey": "1678313b",
      "slug": "porto-ceresio",
      "name": "Porto Ceresio",
      "primary": true,
      "skipSearch": false
    }],
    "monte-casolo": [{
      "hkey": "1678313b",
      "slug": "porto-ceresio",
      "name": "Porto Ceresio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0eb4fa61": [{
      "hkey": "1678313b",
      "slug": "porto-ceresio",
      "name": "Porto Ceresio",
      "primary": true,
      "skipSearch": false
    }],
    "monte-grumello": [{
      "hkey": "1678313b",
      "slug": "porto-ceresio",
      "name": "Porto Ceresio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3f1b1009": [{
      "hkey": "1678313b",
      "slug": "porto-ceresio",
      "name": "Porto Ceresio",
      "primary": true,
      "skipSearch": false
    }],
    "poncia": [{
      "hkey": "1678313b",
      "slug": "porto-ceresio",
      "name": "Porto Ceresio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2aff5e54": [{
      "hkey": "1678313b",
      "slug": "porto-ceresio",
      "name": "Porto Ceresio",
      "primary": true,
      "skipSearch": false
    }],
    "ronco-falcione": [{
      "hkey": "1678313b",
      "slug": "porto-ceresio",
      "name": "Porto Ceresio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5efb53dc": [{
      "hkey": "1678313b",
      "slug": "porto-ceresio",
      "name": "Porto Ceresio",
      "primary": true,
      "skipSearch": false
    }],
    "selva-piana": [{
      "hkey": "1678313b",
      "slug": "porto-ceresio",
      "name": "Porto Ceresio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;